const prefix = 'fac';
const iconName = 'admin';
const width = 495;
const height = 504;
const ligatures = [];
const unicode = null;
const svgPathData = 'M229.926 296C225.423 310.876 223 326.655 223 343C223 351.511 223.657 359.869 224.922 368.026L88.9492 504H29.7002C13.3002 504 0 490.7 0 474.3C9.89229e-05 375.8 79.7999 296 178.3 296H229.926ZM208 0C274.3 0 328 53.7 328 120C328 186.3 274.3 240 208 240C141.7 240 88 186.3 88 120C88 53.7 141.7 0 208 0Z M384.841 233C398.68 233 411.968 235.548 424.154 240.229C431.039 242.846 432.278 251.59 427.114 256.822L366.045 317.892C363.98 319.957 362.809 322.779 362.809 325.671V354.175C362.809 360.234 367.766 365.191 373.825 365.191H402.329C405.221 365.191 408.043 364.02 410.108 361.955L471.178 300.886C476.41 295.653 485.154 296.961 487.771 303.846C492.452 316.032 495 329.32 495 343.159C495 404.022 445.704 453.318 384.841 453.318C372.792 453.318 361.157 451.391 350.278 447.811L294.089 504H153.911L280.189 377.722C276.609 366.843 274.682 355.277 274.682 343.159C274.682 282.296 323.978 233 384.841 233Z';

export const definition = {
    prefix,
    iconName,
    icon: [
        width,
        height,
        ligatures,
        unicode,
        svgPathData,
    ],
};

export { definition as faAdmin };
